// (C) Copyright 2025 Hewlett Packard Enterprise Development LP
import React from 'react';
import ReactDOM from 'react-dom';
import { isOnPrem } from './utils/session';

function loadEntryPoint() {
  if (isOnPrem()) {
    return import('./index-pced');
  }
  return import('./index-pce');
}

loadEntryPoint().then(({ default: App }) => {
  ReactDOM.render(<App />, document.getElementById('root'));
});
